import { render, staticRenderFns } from "./OverlayLoadingText.vue?vue&type=template&id=4a538413&"
import script from "./OverlayLoadingText.vue?vue&type=script&lang=js&"
export * from "./OverlayLoadingText.vue?vue&type=script&lang=js&"
import style0 from "./OverlayLoadingText.vue?vue&type=style&index=0&id=4a538413&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports